export default () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8333 1.34102L10.6583 0.166016L5.99999 4.82435L1.34166 0.166016L0.166656 1.34102L4.82499 5.99935L0.166656 10.6577L1.34166 11.8327L5.99999 7.17435L10.6583 11.8327L11.8333 10.6577L7.17499 5.99935L11.8333 1.34102Z"
        fill="black"
      />
    </svg>
  );
};
